module.exports = __webpack_public_path__ + "media/featured_internships/CTA_btn-22327264.png";